<template>
  <v-container>
    <v-form v-model="valid">
      <v-row>
        <v-col cols="12" sm="12">
          <v-text-field
            v-model="name"
            :rules="[rules.required, rules.min, rules.max]"
            :label="$t('Networks.name')"
            hint="Between 3 and 30 characters"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="12">
          <v-text-field
            v-model="networkId"
            :rules="[rules.uuid]"
            hint="Must be uuidv4"
          >
            <template v-slot:label>
              <div>
                {{ $t("Networks.id") }}
                <small>{{ $t("Networks.optionnal") }}</small>
              </div>
            </template></v-text-field
          >
        </v-col>
        <v-col cols="12" sm="12">
          <v-textarea v-model="description" auto-grow rows="1">
            <template v-slot:label>
              <div>
                {{ $t("Networks.description") }}
                <small>{{ $t("Networks.optionnal") }}</small>
              </div>
            </template>
          </v-textarea>
        </v-col>
      </v-row>
    </v-form>
    <save-buttons
      :networkToCreate="networkToCreate"
      :path="path"
      @back="$emit('back')"
      @error="error"
      @saved="saved"
    ></save-buttons>
  </v-container>
</template>

<script>
import SaveButtonsComponent from "./SaveButtons.vue";

export default {
  components: {
    "save-buttons": SaveButtonsComponent,
  },
  props: {
    path: String,
  },
  data() {
    return {
      name: "",
      description: "",
      valid: false,
      networkId: "",
      rules: {
        uuid: (v) =>
          v=="" || /^[0-9A-F]{8}-[0-9A-F]{4}-[4][0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i.test(
            v
          ) || "Not a uuidv4",
        required: (value) => !!value || this.$t("Networks.rules.required"),
        min: (v) => v.length >= 3 || this.$t("Networks.rules.min"),
        max: (v) => v.length <= 30 || this.$t("Networks.rules.max"),
      },
    };
  },
  computed: {
    networkToCreate: function () {
      let json = {
        name: this.name,
        valid: this.valid,
      };
      if (this.networkId != "") json.networkId = this.networkId;
      if (this.description != "") json.description = this.description;
      console.log(json);
      return json;
    },
  },
  methods: {
    error: function (value) {
      this.$emit("error", value);
    },
    saved: function (value) {
      this.$emit("saved", value);
    },
  },
};
</script>